import { RemocalWidget, shouldShowRemocalWidget } from "@jsq/common-components";
import { Flex, Tabs, Link } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Page, NavbarContainer, NavbarDropdown } from "@jsq/ds/layouts";
import { Colors } from "@jsq/ds/styles";
import CanopyLogo from "~/static/canopy_logo.svg";
import { NavConfig } from "./NavConfig";
import * as styles from "./styles_vanilla.css";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Page className={styles.page}>
      <NavbarContainer className={styles.homeNavBarStyle}>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          className={styles.fullWidthFlex}
        >
          <Link to="/" className={styles.logoLink}>
            <Flex alignItems="center" gap="8px">
              {process.env.NODE_ENV === "development" && (
                <div className={styles.devModeIndicator} title="Development Mode" />
              )}
              <img alt="Canopy" src={CanopyLogo} />
            </Flex>
          </Link>
          <Tabs hasBottomBorder={false} className={styles.autoMarginLeftTabs}>
            <NavConfig />
          </Tabs>
          <Flex alignItems="center">
            <NavbarDropdown
              dropDownClassName={styles.dropdownStyle}
              position="bottomRight"
              theme="dark"
              actionItem={
                <Icon
                  type="cog"
                  variant="outline"
                  color={Colors.Neutral400}
                  size="large"
                  data-testid="home_settings"
                />
              }
              data-cy="dropdown"
            >
              <Link
                href="/logout"
                variant="neutral"
                data-cy="global-logout"
                className={styles.navDropdownItem}
              >
                Logout
              </Link>
            </NavbarDropdown>
          </Flex>
        </Flex>
      </NavbarContainer>
      {children}
      {shouldShowRemocalWidget() && <RemocalWidget />}
    </Page>
  );
};
